import NextImage from '@/components/ui/next-image';
import { useTranslations } from 'next-intl';
import React, { memo, useState } from 'react';

const ConfigurableItem = ({
  title,
  options,
  currentOption,
  onChangeCurrentOption,
}) => {
  const t = useTranslations('common');

  const [active, setActive] = useState(currentOption?.[title]?.option_value);

  return (
    <div className='flex flex-col gap-3'>
      <div className={`font-extrabold sm:text-lg md:text-xl`}>
        {t(title)}{' '}
        <span className='font-normal'>({currentOption?.[title]?.label})</span>
      </div>
      <div className='flex flex-wrap items-center gap-4'>
        {options?.map((option, i) => (
          <button
            disabled={option?.isDisabled}
            onClick={() => {
              setActive(option?.option_value);
              option?.option_value !== active &&
                onChangeCurrentOption({ [title]: option });
            }}
            className={`border-border flex flex-col items-center justify-center border p-2 ${
              active === option?.option_value ? 'border-red-500' : ''
            } rounded-sm disabled:cursor-not-allowed disabled:opacity-50`}
            key={i}
          >
            {configTypeHandler(title, option)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default memo(ConfigurableItem);

const configTypeHandler = (title, option) => {
  switch (title) {
    case 'color':
      return option?.image ? (
        <NextImage
          src={option?.image}
          loading='eager'
          className='min-h-[45px] object-contain'
          height={45}
          width={45}
          alt='Color Img!'
        />
      ) : (
        <span className={`block font-bold text-zinc-500`} dir='ltr'>
          {option?.label || '--'}
        </span>
      );
    default:
      return (
        <span className={`block font-bold text-zinc-500`} dir='ltr'>
          {option?.label || '--'}
        </span>
      );
  }
};
